import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { AdExamplesCard } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/AdExamplesCard/AdExamplesCard';
import { ClicksForecastCard } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/ClicksForecastCard/ClicksForecastCard';
import { SourceDisableCard } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/SourceDisableCard/SourceDisableCard';

import { useSelector } from 'store/utils';

const SourcesAndBudgetsSidebarComponent: FC = () => {
    const { pricePerClick } = useSelector((state) => state.createCampaign);

    return (
        <>
            <SourceDisableCard />
            <VSpacing default={20} />
            <AdExamplesCard />
            <VSpacing default={20} />
            {!!pricePerClick && <ClicksForecastCard />}
            <VSpacing default={32} />
        </>
    );
};

const SourcesAndBudgetsSidebar = withErrorBoundary(SourcesAndBudgetsSidebarComponent);
export { SourcesAndBudgetsSidebar };
